import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Store } from "lucide-react";
import { fmtNum } from "@/lib/format";

const isAdmin = () => { try { return ["super_admin", "brand_admin"].includes(JSON.parse(localStorage.getItem("kazo_user") || "{}").role); } catch { return false; } };

/* Re-map every customer's Home + Registered store to their first-purchase store
   (members with no purchase → their registration store). Runs in the background. */
export const HomeStoreRemapButton = ({ onDone }) => {
  const [st, setSt] = useState(null);
  const load = useCallback(() => api.get("/kpi-reports/home-store-remap").then((r) => setSt(r.data)).catch(() => {}), []);
  useEffect(() => { if (isAdmin()) load(); }, [load]);
  useEffect(() => {
    if (st?.status !== "running") return undefined;
    const t = setInterval(async () => {
      const r = await api.get("/kpi-reports/home-store-remap").catch(() => null);
      if (r) { setSt(r.data); if (r.data.status === "done") { toast.success("Home & registered stores re-mapped"); onDone(); } }
    }, 5000);
    return () => clearInterval(t);
  }, [st, onDone]);
  if (!isAdmin()) return null;

  const start = async () => {
    if (!window.confirm("Set every customer's Home store and Registered store to their FIRST purchase store (no-purchase members → registration store)?")) return;
    try { await api.post("/kpi-reports/home-store-remap"); setSt({ status: "running" }); toast.info("Re-mapping in the background…"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not start"); }
  };
  const running = st?.status === "running";
  return (
    <button onClick={start} disabled={running} className="k-btn k-btn-outline" data-testid="crm-remap-home-store"
      title={st?.status === "done" ? `Last run: ${fmtNum(st.buyers_mapped)} buyers + ${fmtNum(st.non_buyers_mapped)} members mapped` : ""}>
      <Store className={`w-3.5 h-3.5 ${running ? "animate-pulse" : ""}`} />
      {running ? `Re-mapping… ${st?.buyers_done ? fmtNum(st.buyers_done) : ""}` : "Re-map home stores"}
    </button>
  );
};
